var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEurFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A47B8",
    d: "M0 0h60v45H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.286 0H5.714C2.558 0 0 2.686 0 6v33c0 3.314 2.558 6 5.714 6h48.572C57.442 45 60 42.314 60 39V6c0-3.314-2.558-6-5.714-6Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m30 5.625.754 1.743 1.84.2-1.375 1.278.384 1.867L30 9.759l-1.603.954.384-1.867-1.375-1.278 1.84-.2L30 5.625ZM17.117 21.431l-.753-1.744-.754 1.744-1.84.2 1.375 1.277-.384 1.867 1.603-.953 1.603.953-.384-1.866 1.375-1.278-1.84-.2Zm27.273 0-.754-1.744-.753 1.744-1.84.2 1.374 1.277-.384 1.867 1.603-.953 1.604.953-.384-1.866 1.374-1.278-1.84-.2ZM30.754 35.493 30 33.75l-.753 1.743-1.84.2 1.374 1.278-.384 1.867L30 37.884l1.603.954-.384-1.867 1.375-1.278-1.84-.2Zm-10.3-5.962.754 1.743 1.84.2-1.374 1.278.384 1.867-1.603-.953-1.603.953.384-1.867-1.375-1.277 1.84-.2.754-1.744Zm.754-17.944-.753-1.743-.754 1.743-1.84.2 1.375 1.278-.384 1.867 1.603-.954 1.603.954-.384-1.867 1.375-1.278-1.84-.2ZM39.546 29.53l.753 1.743 1.84.2-1.374 1.278.384 1.867-1.603-.953-1.603.953.384-1.867-1.375-1.277 1.84-.2.754-1.744Zm.753-17.944-.753-1.743-.754 1.743-1.84.2 1.375 1.278-.384 1.867 1.603-.954 1.603.954-.384-1.867 1.374-1.278-1.84-.2Z",
    fill: "#FF0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEurFlag);
export default __webpack_public_path__ + "static/media/eur-flag.ae6bd4dab2cb7d3b2972d53b2d08d668.svg";
export { ForwardRef as ReactComponent };